import Vue from 'vue'
// require('es6-promise').polyfill();
// var axios = require('axios');
import axios from 'axios';
// import store from '@/core/store/index';
import iView from 'iview'
import router from '@/router/index'
import global from '@/core/global/global'
import JSEncrypt from 'jsencrypt';
var param = global.global.getParam();
const isDev = !process.env.NODE_ENV === 'development' //true为开发环境
let ajaxconfig = {
  // 基础url前缀
  baseURL: isDev ? "/apis" : "",
  //设置超时时间
  timeout: 300000,
  //返回数据类型
  responseType: 'json', // default
  //请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
  url: '/',

  // 请求方法同上
  method: 'get', // default
  transformRequest: [function (data) {
    // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
    //data = axios.stringify(data);
    ////console.log("data",typeof data,data)
    ////console.log(data.method)
    return data;
  }],

  transformResponse: [function (data) {
    // 这里提前处理返回的数据
    // //console.log(121,data)

    if (typeof data == 'string') {
      data = JSON.parse(data);
    }
    return data;
  }],
  // 请求头信息
  headers: {
    'Content-Type': 'application/json', //application/json application/x-www-form-urlencoded
  },
  //parameter参数
  params: {},
  //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
  data: {},
  withCredentials: true //当我们把此配置项设置成默认配置项并且设置成true的时候，axios就可以设置cookies了。
};

let instance = axios.create(ajaxconfig);
//请求列表数据
function queryData(options, callBack) {

  var authorization = "";//从session中取出token
  //if(sessionStorage.getItem("userInfo")){
  //  var userInfo=JSON.parse(sessionStorage.getItem("userInfo"));//取出sesion
  //  authorization=userInfo.token;
  //}else{
  //  authorization=""
  //}
  //必须基本设置请求参数
  // 发测试使用
  //var dev = '/tsg'
  var dev = '/tsg-author'

  // 本地使用
  // var dev = '';
  if (!isDev) {
    if (options.url.indexOf('txpy-web') != -1) {
      dev = global.global.url2.replace('/txpy-web', '')
    } else if (options.url.indexOf('tsg-author') != -1) {
      dev = global.global.url.replace('/tsg-author', '')
    }
  }

  let url = dev + options.url || '';
  let method = options.method || ajaxconfig.method; //"get" "post"  "put" ，默认请求get
  let dataType = options.dataType || "";
  let isParseStringJSON = options['jsonString'];
  let isToken = options['isToken'];

  //扩展基本配置项
  let myConfig = options.baseConfing || {}; //{}

  let config = _.defaultsDeep({}, myConfig);
  config.method = method;
  //获取服务端数据
  if (method == 'post' || method == 'put' || method == 'patch' || method == 'delete') {

    //POST提交数据时必选参数
    let potsData = options.data || {}; //{firstName: 'Fred',lastName: 'FlintStone'}
    if (method == "post" && dataType == "formData") {
      callBack(instance);
      return instance[method](url, potsData);
    }

    if (_.isObject(potsData)) {
      if (typeof isParseStringJSON != 'undefined') {
        setAjaxQuestHeader('Content-Type', 'application/json;charset=UTF-8');
        potsData = JSON.stringify(potsData);
      } else {
        //application/x-www-form-urlencoded
        setAjaxQuestHeader('Content-Type', 'application/json;charset=UTF-8');
        potsData = JSON.stringify(potsData);
      }
    }
    callBack(instance);
    if (method == "delete") {
      potsData = { data: potsData };
    }
    instance.defaults.headers["Zw-Type"] = 'ajax/json';
    let token = window.sessionStorage.getItem('token')
    if (param.token && !isToken) {
      instance.defaults.headers.token = token;
    } else {
      delete instance.defaults.headers.token
    }
    return instance[method].bind(instance, url, potsData, config);
  } else {
    //GET提交数据时必选参数
    let myParams = options.params || {}; //{params: {ID: 12345}} || '/user?ID=12345'
    myParams = Object.assign({}, myParams, {
      // mathRand: Math.random() * 100000000000000000
      time: new Date().getTime()
    });
    config.params = myParams;
    // if(method=="delete"){
    //   instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    // }
    callBack(instance);

    instance.defaults.headers["Zw-Type"] = 'ajax/json';
    let token = window.sessionStorage.getItem('token')
    if (token && !isToken) {
      instance.defaults.headers.token = token;
    } else {
      delete instance.defaults.headers.token
    }
    return instance[method].bind(instance, url, config);
  }
}

//JSON序列化传入参数形式

function serializeParams(params, type) {
  if (!params) return;
  let obj = {};
  if (type == 'JSON') {
    if (!_.isString(params)) return;
    if (params.indexOf('&') > -1) {
      let splits = params.split('&');
      splits.forEach(function (v, k) {
        let key = v.split('=')[0] || k;
        let val = v.split('=')[1] || undefined;
        obj[key] = val;
      });
      return obj;
    }
  } else {
    if (!_.isObject(params)) {
      if (!_.isObject(JSON.parse(params))) {
        return;
      } else {
        params = JSON.parse(params);
      }
    }
    obj = [];
    _.forEach(params, function (v, k) {
      v = !v ? '' : v;
      let val = k + '=' + v;
      obj.push(val);
    });
    return obj.join('&');
  }
}

//请求前改变请求头源参数
function setAjaxQuestHeader(key, v) {
  ajaxconfig['headers'][key] = v;
  instance = axios.create(ajaxconfig);
}
let ajax = function (option) {
  return queryData(option, function (instance) {
    // 拦截器
    //请求响应
    instance.interceptors.request.use(
      config => {
        // //console.log(111,config)
        let trip = sessionStorage.getItem("trip");
        if (trip) {
          var encryptStr = new JSEncrypt();
          encryptStr.setPublicKey(trip); //设置加密公钥
          const randomNum = Math.floor(10000000 + Math.random() * 90000000);
          const cnSign =
            randomNum + "zwjt8081!@#DF*F&^SKD" + new Date().getTime();
          const encryptCnSign = encryptStr.encrypt(cnSign); //进行加密
          config.headers["cn-sign"] = encryptCnSign;
        }
        iView.LoadingBar.start();
        return config
      },
      error => {
        console.log(error);
      })
    //响应拦截器
    instance.interceptors.response.use(config => {
      //token 验证失败
      var gitlist_ha = window.sessionStorage.getItem("gitlist_ha");
      if (config && config.data) {
        // if (config.data.resultCode == '1009') {
        //   iView.Message.warning("登录超时!");
        //   return;
        // }
        if (config.data.resultCode == "1001" || config.data.resultCode == "4001" || config.data.resultCode == "1003" || config.data.resultCode == "1009") {
          if (gitlist_ha) {
            iView.Message.warning("登录超时!");
          } else {
            iView.Message.warning("登录超时，请重新登录");
            setTimeout(function () {
              sessionStorage.clear()
              window.location.href = window.location.protocol + '//' + window.location.host + '/' + window.location.search
            }, 3000)
            return;
          }

        }
        config.data = config.data || JSON.parse(config.request.responseText);
      }

      iView.LoadingBar.finish();
      return config;
    }, error => {
      iView.LoadingBar.finish();
      if (error.response) {
        if (error.response.resultCode == 500 || error.response.resultCode == 502) {
          iView.Message.warning("数据加载失败，请稍后再试");
        } else if (error.response.resultCode == 404) {
          iView.Message.warning("数据加载地址请核实");
        }
      }
    });

  })();
};



export default ajax;
